define([
	"dojo/_base/declare",
	"csi/table/Delete"
], function(declare,Delete) {

	return declare(Delete, {
		_bSelected: false,
		
		confirmAction: function(/*Object*/params) {
			var	prodSourcing = this.m_cache.addNode(this.m_urlParent);
			
			if (prodSourcing.SelectedCostScenario == this.m_urlNode) {
				params.message = this.getString("_ConfirmSelected");
				this._bSelected = true;
			}

			this.inherited(arguments);
		},
		
		postProcessSuccess: function() {
			// summary: if selected scenario is deleted, then refresh summary view
			if (this._bSelected) {
				var	viewSummary = this.widget.viewParent.getChildView("Summary");
				if (viewSummary) {
					viewSummary.refreshWidget();
				}
			}
			
			this.inherited(arguments);
		}
	});
});